// extracted by mini-css-extract-plugin
export default {"feedContainer":"feed_feedContainer__-67Qa"};